import { TypeSpan } from '../cells/TypeSpan';
import styled from '@emotion/styled';

export const LedgerType = styled(TypeSpan)`
  width: 130px;
  min-width: 130px;
`;
